import type {SxProps} from '@mui/system';
import {useTheme} from '@mui/material';
import {Layout} from 'components/layout';
import {Text} from 'components/text';

type Props = {
  code: string;
};

export const ThesaurusCode: React.FC<Props> = ({code}) => {
  const {colors} = useTheme();

  const sx: SxProps = {
    borderRadius: 1,
    background: colors.beige,
    padding: 1,
  };

  return (
    <Layout sx={sx}>
      <Text variant="body2">{code}</Text>
    </Layout>
  );
};
